import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow } from 'material-ui/Table';
import TextField from 'material-ui/TextField';
import Pagination from 'components/Libs/Pagination';

import { searchPort } from 'actions/regions/ports';
import styles from 'styles';
import PortsTableRow from './Row';

class PortsAltNamesTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rowsPerPage: [10, 20, 30, 50, 100],
            rows: [],
            numberOfRows: 10,
            page: 1,
            total: undefined,
            ports: [],
        };

        this.handleUpdateRow = this.handleUpdateRow.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    filterSearch(searchArray, searchText) {
        if (searchText === '') {
            return searchArray;
        }

        return searchArray.filter((item) => {
            if (item.prevState.name) {
                if (item.prevState.name.toLowerCase().includes(searchText)) {
                    return true;
                }
            }

            for (let i = 0; i < item.prevState.alt.length; i++) {
                if (item.prevState.alt[i].toLowerCase().includes(searchText)) {
                    return true;
                }
            }

            return false;
        });
    }

    makeFilter(props) {
        let page = this.state.page;

        if (props.searchText !== this.props.searchText) {
            page = 1;
        }

        const ports = this.filterSearch(props.ports, props.searchText);

        this.setState({
            searchText: props.searchText,
            ports,
            page,
            total: props.ports.length,
        }, () => {
            this.handleUpdateRow(this.state);
        });
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (props.ports.length) {
            this.makeFilter(props);
        }
    }

    changeRowsByPagination(state) {
        const elementsOnPage = state.numberOfRows;
        const offset = state.page - 1;
        const from = offset * elementsOnPage;
        const to = (offset * elementsOnPage) + elementsOnPage;

        return this.state.ports.slice(from, to);
    }

    handleUpdateRow(newState) {
        const rows = this.changeRowsByPagination(newState);
        const state = newState;
        state.rows = rows;

        this.setState(state);
    }

    handleSearch(e) {
        this.props.searchPort(e.target.value.toLowerCase());
    }

    render() {
        const searchText = this.props.searchText;
        const rows = this.state.rows;

        let renderSuggestions = (
            <div className='port-suggestions'>
                <div className='title'>This name has been already used:</div>
                <div className='content'>
                    {
                        this.props.suggestionsPorts.map(port => (port.alt ? ` ${port.name} - (${port.alt.join(', ')}), ` : `${port.name}, `))
                    }
                </div>
            </div> 
        );

        let renderPagination = (<Pagination
            total={this.state.ports.length}
            rowsPerPage={this.state.rowsPerPage}
            page={this.state.page}
            numberOfRows={this.state.numberOfRows}
            updateRows={this.handleUpdateRow}
        />);

        let renderTable = (
            <Table selectable={false}>
                <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                    <TableRow>
                        <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                        name port
                        </TableHeaderColumn>
                        <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                        alt
                        </TableHeaderColumn>
                        <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                            {null}
                        </TableHeaderColumn>
                    </TableRow>
                </TableHeader>

                <TableBody displayRowCheckbox={false}>
                    {
                        rows.map(row => (<PortsTableRow key={row._id} item={row} />))
                    }
                </TableBody>
            </Table>
        );

        if (!this.props.suggestionsPorts.length) {
            renderSuggestions = null;
        }

        if (!rows.length) {
            renderTable = (<div className='nothing-found'>Not found</div>);
            renderPagination = null;
        }

        return (
            <div>
                <div className='table-header'>
                    <div className='item'>
                        <TextField
                            defaultValue={searchText}
                            floatingLabelText='Search'
                            onChange={this.handleSearch}
                        />
                    </div>

                    <div className='item'>
                        {renderPagination}
                    </div>
                </div>

                {renderSuggestions}

                <div className='table-body'>
                    {renderTable}
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        searchText: state.ports.searchText,
        ports: state.ports.items,
        suggestionsPorts: state.ports.suggestions,
    }),
    dispatch => bindActionCreators(
        {
            searchPort,
        },
        dispatch,
    ),
)(PortsAltNamesTable);



// WEBPACK FOOTER //
// ./app/components/Regions/PortsAltNames/Table.jsx